import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { fetchUserCoupons } from '../../api/couponsApi';

const couponMainColor = '#ec529a'; // כמו בדף פרופיל
const couponBorderColors = ['#0cad5e', '#ef4882', '#a261a7']; // שלושת הצבעים האחרים

const Coupons = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    if (!user) navigate('/', { replace: true });
  }, [user, user?.id, navigate]);

  useEffect(() => {
    if (user?.id) {
      fetchUserCoupons(user.id).then(setCoupons).catch(() => setCoupons([]));
    }
  }, [user]);

  const items = user?.coupons || [];

  if (!user) return null;

  return (
    <div className="coupons-root" style={{ background: '#fff' }}>
              <button onClick={() => navigate('/profile')} className="back-button" style={{marginLeft: '16px', marginBottom: '0', marginTop: '0'}}>← חזרה לאזור אישי</button>
      <div className="coupons-header" style={{ color: couponMainColor }}>
        <span className="coupons-title">הקופונים שלי</span>
        <svg width="40" height="32" viewBox="0 0 24 24" fill="none" stroke={couponMainColor}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: 8 }}>
          <path d="M2 9a3 3 0 0 1 0-6h20a3 3 0 0 1 0 6 3 3 0 0 0 0 6 3 3 0 0 1 0 6H2a3 3 0 0 1 0-6 3 3 0 0 0 0-6z" />
        </svg>
      </div>
      <div className="coupons-list" style={{ border: `1px solid ${couponMainColor}` }}>
        {coupons.length === 0 && <div className="no-coupons">אין קופונים להצגה</div>}
        {coupons.map((coupon, idx) => (
          <div
            className="coupon-card"
            key={coupon.id}
            style={{ border: `1px solid ${couponBorderColors[idx % couponBorderColors.length]}` }}
          >
            <div
              className="coupon-code"
              style={{
                background: couponBorderColors[idx % couponBorderColors.length],
              }}
            >
              {coupon.coupon_code}
            </div>
            <div className="coupon-desc">{coupon.description}</div>
            <div style={{fontWeight: 'bold'}} >
              {coupon.is_percentage
                ? `${coupon.discount_amount}%`
                : `₪  ${coupon.discount_amount} `}
            </div>          </div>
        ))}
      </div>
    </div>
  );
};

export default Coupons;


